import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Hero from './components/Hero';
import Features from './components/Features';
import Waitlist from './components/Waitlist';
import Footer from './components/Footer';
import About from './pages/About';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import ComingSoon from './pages/ComingSoon';

// Home Page Component
function Home({ onJoinWaitlist }) {
  return (
    <>
      {/* Fixed Coming Soon Banner */}
      <div className="coming-soon-banner">
        <span className="pulse-dot"></span>
        <span>Coming Soon - Join the waitlist for early access</span>
      </div>
      
      <Hero onJoinWaitlist={onJoinWaitlist} />
      <Features />
      <Footer />
    </>
  );
}

function App() {
  const [isWaitlistOpen, setIsWaitlistOpen] = useState(false);

  const handleJoinWaitlist = () => {
    setIsWaitlistOpen(true);
  };

  const handleCloseWaitlist = () => {
    setIsWaitlistOpen(false);
  };

  return (
    <Router>
      <div style={{minHeight: '100vh'}}>
        <Routes>
          <Route path="/" element={<Home onJoinWaitlist={handleJoinWaitlist} />} />
          <Route path="/about" element={<><About /><Footer /></>} />
          <Route path="/pricing" element={<><Pricing /><Footer /></>} />
          <Route path="/contact" element={<><Contact /><Footer /></>} />
          <Route path="/privacy" element={<><Privacy /><Footer /></>} />
          <Route path="/terms" element={<><Terms /><Footer /></>} />
          
          {/* Coming Soon Pages */}
          <Route path="/api" element={<ComingSoon />} />
          <Route path="/documentation" element={<ComingSoon />} />
          <Route path="/blog" element={<ComingSoon />} />
          <Route path="/careers" element={<ComingSoon />} />
        </Routes>
        
        <Waitlist 
          isOpen={isWaitlistOpen} 
          onClose={handleCloseWaitlist} 
        />
        
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
